import React, { useState } from "react";
import { Grid, Pagination } from "@mantine/core";

import { GeospotItem } from "./";

const PAGE_SIZE = 12;

export default function GeospotList({
  editable = true,
  items,
  fetchData,
  colspan = { base: 12, md: 6, lg: 4 },
}) {
  const [activePage, setPage] = useState(1);
  const displayItems = items.slice(
    (activePage - 1) * PAGE_SIZE,
    activePage * PAGE_SIZE
  );

  return (
    <div>
      <Grid>
        {displayItems.map((item) => (
          <Grid.Col span={colspan} key={item.id}>
            <GeospotItem
              data={item}
              id={item.id}
              fetchData={fetchData}
              editable={editable}
            />
          </Grid.Col>
        ))}
      </Grid>
      {items.length > PAGE_SIZE && (
        <Pagination
          total={Math.ceil(items.length / PAGE_SIZE)}
          value={activePage}
          onChange={setPage}
        />
      )}
    </div>
  );
}
